/*
 * @Author: Jing
 * @Date: 2021-11-04 18:05:46
 * @Descripttion:
 */
import { createStore } from 'vuex'

let userMember = localStorage.getItem('accountId')

export default createStore({
    state: {
        accountId: userMember ? userMember : '',
        payInfo: null,
        // 自助机登录信息
        selfHelpLogin: null,
    },
    getters: {
        getAccount: (state) => {
            return state.accountId
        },
        getPayInfo: (state) => {
            return state.payInfo
        },
        getSelfHelpLogin: (state) => {
            return state.selfHelpLogin
        },
    },
    mutations: {
        SET_MEMBER(state, data) {
            localStorage.setItem('accountId', data)
            state.accountId = data
        },
        SET_PAYINFO(state, data) {
            state.payInfo = data
        },
        SET_SELFHELPLOGIN(state, data) {
            state.selfHelpLogin = data
        },
    },
    actions: {
        setMember({ commit }, info) {
            commit('SET_MEMBER', info)
        },
        setPayInfo({ commit }, info) {
            commit('SET_PAYINFO', info)
        },
        setSelfHelpLogin({ commit }, info) {
            commit('SET_SELFHELPLOGIN', info)
        },
    },
})
